import styled from 'styled-components';

import Link from '@Components/atoms/Link';
import { TooltipTrigger } from '@Components/atoms/Tooltip/Tooltip';

export const Root = styled.div`
  display: flex;
  flex-grow: 1;
  min-width: 0;
`;

export const StyledTooltipTrigger = styled(TooltipTrigger)`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  min-width: 0;
  align-items: center;
  gap: ${(props) => props.theme.space.xs_4};
`;

export const UsernameText = styled(Link)`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
